import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 9,
	viewBox: "0 0 12 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.00078 6.60005L9.90078 0.700048C10.0841 0.516715 10.3174 0.425049 10.6008 0.425049C10.8841 0.425049 11.1174 0.516715 11.3008 0.700048C11.4841 0.883382 11.5758 1.11671 11.5758 1.40005C11.5758 1.68338 11.4841 1.91672 11.3008 2.10005L4.70078 8.70005C4.50078 8.90005 4.26745 9.00005 4.00078 9.00005C3.73411 9.00005 3.50078 8.90005 3.30078 8.70005L0.700781 6.10005C0.517448 5.91672 0.425781 5.68338 0.425781 5.40005C0.425781 5.11671 0.517448 4.88338 0.700781 4.70005C0.884114 4.51672 1.11745 4.42505 1.40078 4.42505C1.68411 4.42505 1.91745 4.51672 2.10078 4.70005L4.00078 6.60005Z",
		fill: "currentColor"
	})
});
export default SvgCheck;
